const IconSend = ({ className }) => {
    return (
        <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.7071 2.29292C21.9813 2.56708 22.0722 2.975 21.9406 3.33967L15.4406 21.3397C15.4312 21.3657 15.4207 21.3914 15.4092 21.4166C15.2855 21.6864 15.087 21.9151 14.8372 22.0754C14.5874 22.2357 14.2969 22.3209 14.0001 22.3209C13.7033 22.3209 13.4127 22.2357 13.1629 22.0754C12.9191 21.9189 12.7242 21.6974 12.6 21.4359L9.25465 14.7454L2.5642 11.4001C2.30276 11.276 2.08118 11.081 1.92471 10.8372C1.76441 10.5874 1.6792 10.2968 1.6792 10C1.6792 9.70323 1.76441 9.41267 1.92471 9.16288C2.08501 8.9131 2.31366 8.71458 2.58347 8.59094C2.60868 8.57939 2.63435 8.56889 2.66042 8.55947L20.6604 2.05947C21.025 1.92779 21.4329 2.01876 21.7071 2.29292ZM11.2168 14.1975L13.9322 19.6283L18.5365 6.8777L11.2168 14.1975ZM17.1223 5.46352L4.37182 10.0679L9.80255 12.7833L17.1223 5.46352Z'
            />
        </svg>
    );
};

export default IconSend;
